<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl4 lg4 xs6>
                      <v-autocomplete :items="makeList" v-model="filters.vehMake" :label="filtersLabel.vehMake" item-text="label" item-value="value" data-vv-name="vehMake" :data-vv-as="filtersLabel.vehMake" :error-messages="errors.collect('vehMake')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vehModel" :label="filtersLabel.vehModel" :error-messages="errors.collect('vehModel')" data-vv-name="vehModel" :data-vv-as="filtersLabel.vehModel"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.vehModelDesc" :label="filtersLabel.vehModelDesc" :error-messages="errors.collect('vehModelDesc')" data-vv-name="vehModelDesc" :data-vv-as="filtersLabel.vehModel"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-autocomplete :items="groupList" v-model="filters.vehGrp" :label="filtersLabel.vehGrp" item-text="label" item-value="value" data-vv-name="vehGrp" :data-vv-as="filtersLabel.vehGrp" :error-messages="errors.collect('vehGrp')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-autocomplete :items="permitStatus" v-model="filters.permitStatusCode" :label="filtersLabel.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="filtersLabel.permitStatus" :error-messages="errors.collect('permitStatus')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.engineCc" :label="filtersLabel.engineCc" :error-messages="errors.collect('engineCc')" data-vv-name="engineCc" :data-vv-as="filtersLabel.engineCc" v-validate="'integer|max:5'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-x-transition" mode="out-in">
                    <v-layout row wrap v-if="showDetailFilters">
                    <v-flex xl4 lg4 xs6>
                      <v-autocomplete :items="bodyTypeList" v-model="filters.bodyType" :label="filtersLabel.bodyType" item-text="label" item-value="value" data-vv-name="bodyType" :data-vv-as="filtersLabel.bodyType" :error-messages="errors.collect('bodyType')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.tonnage" :label="filtersLabel.tonnage" :error-messages="errors.collect('tonnage')" data-vv-name="tonnage" :data-vv-as="filtersLabel.tonnage" v-validate="'numeric|max:5'"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg4 xs6>
                      <v-text-field v-model="filters.noSeats" :label="filtersLabel.noSeats" :error-messages="errors.collect('noSeats')" data-vv-name="noSeats" :data-vv-as="filtersLabel.noSeats" v-validate="'numeric|max:2'"></v-text-field>
                    </v-flex>
                    <!-- Last Part do Filter -->
                    <!-- <v-flex xl4 lg6 xs6>
                      <v-text-field v-model="filters.purchasePrice" :label="filtersLabel.purchasePrice" :error-messages="errors.collect('purchasePrice')" data-vv-name="purchasePrice" :data-vv-as="filtersLabel.inter" v-validate="'decimal|max:7'"></v-text-field>
                    </v-flex>
                    <v-flex xl4 lg6 xs6>
                      <v-text-field v-model="filters.defPriceUOM" :label="filtersLabel.defPriceUOM" :error-messages="errors.collect('defPriceUOM')" data-vv-name="defPriceUOM" :data-vv-as="filtersLabel.defPriceUOM" v-validate="'decimal|max:7'"></v-text-field>
                    </v-flex> -->
                    </v-layout>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" query :review="checkAccess(['vehicleReview'])" @query="doQuery(props.item.vehMake, props.item.vehModel)" @review="doReview(props.item.vehMake, props.item.vehModel)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        New Model
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
    <v-dialog v-model="vehModelDialog" width="800px" lazy persistent >
      <model-dialog :vehModelForm="vehModelForm" @close="doClose" :newModel="newModel" :modelItemDesc="modelItemDesc"></model-dialog>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Vehicle Model? ({{deleteVehModel}})
    </confirm>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { listVehMixin } from '../listVehMixin.js'
import { expandURI, filterQuery } from '@/utils/ajax'
import ModelDialog from './ModelDialog'
export default {
  data() {
    return {
      columns: [
        { text: 'Make', align: 'left', value: 'vehMakeDesc' },
        { text: 'Model Code', value: 'vehModel' },
        { text: 'Model Description', value: 'vehModelDesc' },
        { text: 'Body Type', value: 'bodyTypeDesc' },
        { text: 'Engine CC', value: 'engineCc' },
        { text: 'Tonnage', value: 'tonnage' },
        { text: 'No. Seats', value: 'noSeats' },
        { text: 'Manufacture Year', value: 'manufYr' },
        { text: 'Permit Status', value: 'permitStatusDesc' },
        { text: 'Purchase Price', value: 'purchasePrice' },
        { text: 'Default Price UOM', value: 'defPriceUOM' },
        { text: 'Vehicle Group', value: 'vehGrpDesc' }
      ],
      selectedColumns: ['vehModel', 'vehMakeDesc', 'vehModelDesc', 'vehGrpDesc', 'permitStatusDesc', 'engineCc'],
      totalItems: 0,
      filters: {
        vehMake: null,
        vehModel: null,
        vehModelDesc: null,
        bodyType: null,
        engineCc: null,
        tonnage: null,
        noSeats: null,
        manufYr: null,
        permitStatusCode: null,
        purchasePrice: null,
        defPriceUOM: null,
        vehGrp: null
      },
      filtersLabel: {
        vehMake: 'Make',
        vehModel: 'Model Code',
        vehModelDesc: 'Model Description',
        bodyType: 'Body Type',
        engineCc: 'Engine CC',
        tonnage: 'Tonnage',
        noSeats: 'No. Seats',
        manufYr: 'Manufacture Year',
        permitStatus: 'Permit Status',
        purchasePrice: 'Purchase Price',
        defPriceUOM: 'Defer Price UOM',
        vehGrp: 'Group'
      },
      vehModelForm: {
        vehMake: undefined,
        vehModel: undefined,
        bodyType: undefined,
        engineCC: undefined,
        tonnage: undefined,
        noSeats: undefined,
        manufYr: undefined,
        permitStatus: undefined,
        purchasePrice: undefined,
        defPriceUOM: undefined,
        vehGrp: undefined
      },
      modelItemDesc: {
        query: undefined,
        vehMakeDesc: undefined,
        permitStatusDesc: undefined,
        bodyTypeDesc: undefined,
        vehGrpDesc: undefined
      },
      vehModelDialog: undefined,
      newModel: undefined,
      showDetailFilters: undefined,
      loading: false,
      promptRemove: false,
      selectedVehModel: undefined,
      deleteVehModel: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    permitStatus() {
      return this.$store.state.vehicle.permitStatus
    },
    bodyTypeList() {
      return this.$store.state.vehicle.bodyTypeList
    },
    makeList() {
      return this.$store.state.vehicle.makeList
    },
    groupList() {
      return this.$store.state.vehicle.groupList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    ...mapActions([
      'vehicleList'
    ]),
    async fetchData(options) {
      const apiUrl = this.$store.state.vehicle.menu.getVehModels
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((Model) => {
                const convertModel = {
                  vehMake: Model.vehMake,
                  vehMakeDesc: Model.vehMakeDesc,
                  vehModel: Model.vehModel,
                  vehModelDesc: Model.vehModelDesc,
                  bodyType: Model.bodyType,
                  bodyTypeDesc: Model.bodyTypeDesc,
                  engineCc: Model.engineCc,
                  tonnage: Model.tonnage,
                  noSeats: Model.noSeats,
                  manufYr: Model.manufYr,
                  permitStatusCode: Model.permitStatusCode,
                  permitStatusDesc: Model.permitStatusDesc,
                  purchasePrice: Model.purchasePrice,
                  defPriceUOM: Model.defPriceUOM,
                  vehGrpCode: Model.vehGrp,
                  vehGrpDesc: Model.vehGrpDesc
                }
                this.items.push(convertModel)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.vehMake = null
      this.filters.vehModel = null
      this.filters.vehModelDesc = null
      this.filters.bodyType = null
      this.filters.bodyTypeDesc = null
      this.filters.engineCc = null
      this.filters.tonnage = null
      this.filters.noSeats = null
      this.filters.manufYr = null
      this.filters.permitStatusCode = null
      this.filters.permitStatusDesc = null
      this.filters.purchasePrice = null
      this.filters.defPriceUOM = null
      this.filters.vehGrp = null
      this.filters.vehGrpDesc = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClose() {
      this.vehModelDialog = false
      this.modelItemDesc.query = false
      this.newModel = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.vehModelDialog = true
      this.newModel = true
    },
    async doQuery(vehMake, vehModel) {
      const apiURI = this.$store.state.vehicle.menu.getVehModel
      const expand = {
        vehMake: vehMake,
        vehModel: vehModel
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vehModelForm.vehMake = data.Model.vehMake
          this.vehModelForm.vehModel = data.Model.vehModel
          this.vehModelForm.vehModelDesc = data.Model.vehModelDesc
          this.vehModelForm.bodyType = data.Model.bodyType
          this.vehModelForm.engineCC = data.Model.engineCc
          this.vehModelForm.tonnage = data.Model.tonnage
          this.vehModelForm.noSeats = data.Model.noSeats
          this.vehModelForm.manufYr = data.Model.manufYr
          this.vehModelForm.permitStatus = data.Model.permitStatusCode
          this.vehModelForm.purchasePrice = data.Model.purchasePrice
          this.vehModelForm.defPriceUOM = data.Model.defPriceUOM
          this.vehModelForm.vehGrp = data.Model.vehGrp
          this.modelItemDesc.permitStatusDesc = data.Model.permitStatusDesc
          this.modelItemDesc.bodyTypeDesc = data.Model.bodyTypeDesc
          this.modelItemDesc.vehMakeDesc = data.Model.vehMakeDesc
          this.modelItemDesc.vehGrpDesc = data.Model.vehGrpDesc
          this.modelItemDesc.query = true
        }
        this.vehModelDialog = true
      }
    },
    async doReview(vehMake, vehModel) {
      const apiURI = this.$store.state.vehicle.menu.getVehModel
      const expand = {
        vehMake: vehMake,
        vehModel: vehModel
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vehModelForm.vehMake = data.Model.vehMake
          this.vehModelForm.vehModel = data.Model.vehModel
          this.vehModelForm.vehModelDesc = data.Model.vehModelDesc
          this.vehModelForm.bodyType = data.Model.bodyType
          this.vehModelForm.engineCC = data.Model.engineCc
          this.vehModelForm.tonnage = data.Model.tonnage
          this.vehModelForm.noSeats = data.Model.noSeats
          this.vehModelForm.manufYr = data.Model.manufYr
          this.vehModelForm.permitStatus = data.Model.permitStatusCode
          this.vehModelForm.purchasePrice = data.Model.purchasePrice
          this.vehModelForm.defPriceUOM = data.Model.defPriceUOM
          this.vehModelForm.vehGrp = data.Model.vehGrp
          this.modelItemDesc.permitStatusDesc = data.Model.permitStatusDesc
          this.modelItemDesc.bodyTypeDesc = data.Model.bodyTypeDesc
          this.modelItemDesc.vehMakeDesc = data.Model.vehMakeDesc
          this.modelItemDesc.vehGrpDesc = data.Model.vehGrpDesc
        }
        this.vehModelDialog = true
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVehModel = data
        this.deleteVehModel = data.vehModel + ' - ' + data.vehModelDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vehicle.menu.deleteVehModel
      if (apiURI) {
        this.loading = true
        const expand = {
          vehMake: this.selectedVehModel.vehMake,
          vehModel: this.selectedVehModel.vehModel
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  created() {
    this.apiUrl = this.$store.state.vehicle.menu.getVehModels
  },
  components: {
    ModelDialog: ModelDialog
  },
  mixins: [
    listVehMixin
  ]
}
</script>

<style lang="scss">
</style>
